import { addRoomsToBeConnected, addToCheckoutCart, removeRoomsToBeConnected } from 'actions/CheckoutActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import React, { ComponentProps, useCallback } from 'react'
import MultiRoomOfferCheckoutButton from './MultiRoomOfferCheckoutButton'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import TextButton from 'components/Luxkit/Button/TextButton'
import { showSnackbar } from 'components/Luxkit/Snackbar/AppSnackbar'
import { isAccommodationItem } from 'lib/checkout/checkoutUtils'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  disabled?: boolean;
  checkIn?: string;
  rooms: Array<App.RoomOccupants>;
}

function MultiRoomOfferBookButton(props: Props) {
  const { disabled, checkIn, rooms, ...rest } = props
  const dispatch = useAppDispatch()

  const goToCheckout = useCallback((items: Array<App.Checkout.AnyItem>, connectRooms: boolean, keepBrowsing: boolean) => {
    const offerId = items.find(isAccommodationItem)!.offerId
    dispatch(addToCheckoutCart(items))
    if (connectRooms) {
      dispatch(addRoomsToBeConnected(offerId))
    } else {
      dispatch(removeRoomsToBeConnected(offerId))
    }
    if (keepBrowsing) {
      showSnackbar('Your item has been added to the cart.', 'success', { action: { label: 'View cart', to: '/cart' } })
      return
    }
    dispatch(navigateToCheckout())
  }, [dispatch])

  return <MultiRoomOfferCheckoutButton
    {...rest}
    kind="primary"
    type="submit"
    onProceedToBooking={goToCheckout}
    disabled={disabled}
  >
    {checkIn ? `Book ${rooms.length} rooms now` : 'Check availability'}
  </MultiRoomOfferCheckoutButton>
}

export default withOfferPageState((state) => ({
  checkIn: state.checkInDate,
  rooms: state.rooms,
}))(MultiRoomOfferBookButton)
